import React from 'react'
import PropTypes from 'prop-types'
import './why-trust.scss'

export default class WhyTrust extends React.Component {
  render() {
    return (
      <div className="why-trust">
        <div className="why-trust__wrapper">
          <span className="why-trust__text why-trust__text--bold">Why you can trust me?</span>
          <span className="why-trust__text">I accept nothing from product manufacturers. Never. Here — only unbiased reviews and my opinion. I only earn commission from Amazon</span>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/why-trust/why-trust.js